<template>
	<div>
		<div class="flex flex_justify_between">
			<div>
				<div>
					<p><b>תאריך מסמך</b></p>
					<date-time v-model="document_date" :date="default_document_date"></date-time>
				</div>
				<div class="vertical_space"></div>
				<div class="vertical_space"></div>
				<div class="flex flex_align_center">
					<p><b>מועמד:</b> {{ offer.applicant_name }}</p>
					<div class="horizontal_space"></div>
					<div class="horizontal_space"></div>
					<checkbox v-model="is_anonymous" :checked="is_anonymous">דיסקרטי</checkbox>
				</div>
				<div class="vertical_space"></div>
				<div class="vertical_space"></div>
				<div @click="updateSalary" >
					<p><b>שכר:</b><span class="blue_text btn"> {{ offer.salary }} <b>{{ offer.salary_verified ? '(מאושר)' : '' }}</b></span></p>
				</div>
				<div class="vertical_space"></div>
				<div class="vertical_space"></div>
				<div @click="updatePercentage">
					<p><b>אחוז:</b><span class="blue_text btn"> {{ offer.percentage }} <b>{{ offer.percentage_verified ? '(מאושר)' : '' }}</b></span></p>
				</div>
				<div class="vertical_space"></div>
				<div class="vertical_space"></div>
				<div>
					<p><b>תשלום פלוס מע"מ:</b> {{ $offers_helper.getPayment(offer) }}</p>
				</div>
				<div v-if="isShowReceiptForm">
					<div class="vertical_space"></div>
					<div class="vertical_space"></div>
					<receipt-form v-model="receipt_form"></receipt-form>
				</div>
			</div>
			<div style="border-right: 1px solid rgba(0, 0, 0, 0.1); padding-right: 20px;">
				<div>
					<p><b>Offer Message</b></p>
					<p v-html="$sanitize(offer.message)"></p>
				</div>
				<div class="vertical_space"></div>
				<div class="vertical_space"></div>
				<div>
					<p><b>Company Message</b></p>
					<p v-html="$sanitize(offer.company.message)"></p>
				</div>
			</div>
		</div>
		<div class="modal_footer flex_justify_between">
			<a
				@click="submit()"
				:class="{ 'is-loading': is_loading, faded: isSubmitFaded }"
				class="button is-info"
				>Submit</a
			>
			<p class="red" v-html="$sanitize(error_text)"></p>
		</div>
	</div>
</template>
<script>
	import { mapMutations } from 'vuex'
	import DateTime from '@/components/DateTime'
	import Checkbox from '@/components/Checkbox'
	import ReceiptForm from '@/components/ReceiptForm'
	export default {
		name: 'generate-document',
		props: ['payload'],
		data(){
			let default_document_date = new Date()
			return {
				is_loading: false,
				default_document_date,
				document_date: default_document_date,
				is_anonymous: this.payload.is_anonymous,
				receipt_form: undefined,
				error_text: '',
				offer: null
			}
		},
		created () {
			this.offer = this.payload.offer
		},
		computed: {
			content () {
      	let answer_text = this.questions_helper.getAllAnswersText(this.payload.question)
      	return this.offer.salary ? answer_text : 'CREATE'
    	},
			isShowReceiptForm(){
				return ['invoice_and_receipt', 'receipt'].includes(this.payload.document_type)
			},
			isSubmitFaded(){
				if(this.document_date == undefined){
					return true
				}
				if(this.isShowReceiptForm){
					if(this.receipt_form == undefined || this.receipt_form.payment_terms == undefined){
						return true
					}
					if(this.receipt_form.payment_date == undefined){
						return true
					}
					if(this.receipt_form.payment_terms == 'bank_transfer' && this.receipt_form.reference.length == 0){
						return true
					}
					if(this.receipt_form.payment_terms == 'cheque'){
						let values = ['cheque_number', 'bank_number', 'branch_number', 'account_number']
						for(let i = 0; i < values.length; i++){
							let value = values[i]
							if(this.receipt_form[value].length == 0){
								return true
							}
						}
					}
				}
				return false
			},
		},
		methods: {
			submit(){
				this.error_text = ''
				this.is_loading = true
				this.$network_utils.generateDocument({
					document_type: this.payload.document_type,
					offer_id: this.offer.id,
					is_anonymous: this.is_anonymous,
					date: this.document_date,
					...this.receipt_form
				}).then(response => {
					this.removeModal(this.payload)
					this.is_loading = false;
					this.updateOfferPaymentDate()
					if(this.payload.callback){
						this.payload.callback()
					}
				}).catch(error => {
					this.is_loading = false;
					if(error.response == undefined || error.response.data == undefined){
						this.error_text = 'ארעה שגיאה'
						return
					}
					this.error_text = error.response.data.message
				})
			},
			updateOfferPaymentDate(){
				if(this.receipt_form == undefined){
					return
				}
				this.$network_utils.updateOffer({
					id: this.offer.id,
					payment_date: this.receipt_form.payment_date
				})
			},
			updateOffer() {
				this.$network_utils.getOffer(this.offer.id).then(response => {
					this.offer = response
				})
			},
			updateSalary(){
				this.createModal({
					component_name: 'FieldForm',
					modal_title: `Edit Salary`,
					field_name: 'salary',
					value: this.offer.salary,
					resource_id: this.offer.id,
					resource_type: 'Offer',
					field_type: 'input',
					callback: this.updateOffer
				})
			},
			updatePercentage(){
				this.createModal({
					component_name: 'FieldForm',
					modal_title: `Edit Percentage`,
					field_name: 'percentage',
					value: this.offer.percentage,
					resource_id: this.offer.id,
					resource_type: 'Offer',
					field_type: 'input',
					callback: this.updateOffer
				})
			},
			...mapMutations('modals', ['removeModal', 'createModal'])
		},
		components: {
			DateTime,
			Checkbox,
			ReceiptForm
		}
	}
</script>